import { useEffect } from "react";
import { toast } from "sonner";

/**
 * Listens for `sw-update-available` (dispatched by /public/index.html when a
 * new Service Worker has finished installing) and shows a persistent Sonner
 * toast prompting the user to reload. Clicking "تحديث الآن" tells the waiting
 * SW to skip waiting → the `controllerchange` handler in index.html then
 * reloads the page automatically, guaranteeing the freshest bundle.
 */
export default function SWUpdatePrompt() {
  useEffect(() => {
    const onUpdate = (e) => {
      const reg = e?.detail?.reg;
      const waiting = reg?.waiting;
      toast(
        "يتوفر تحديث جديد للموقع",
        {
          id: "sw-update",
          duration: Infinity,
          description: "لديك إصدار أحدث من مراسم الزوار. حدّث الآن للحصول على آخر المزايا.",
          action: {
            label: "تحديث الآن",
            onClick: () => {
              if (waiting) waiting.postMessage({ type: "SKIP_WAITING" });
              else window.location.reload();
            },
          },
        },
      );
    };
    window.addEventListener("sw-update-available", onUpdate);
    return () => window.removeEventListener("sw-update-available", onUpdate);
  }, []);
  return null;
}
